import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import CardCss from "./CardCss.js";
class Card extends s {
  static get styles() {
    return [CardCss];
  }
  static get properties() {
    return {
      text: { type: String },
      helpText: { attribute: "help-text", type: String | Function },
      helpTextDirection: { attribute: "help-text-direction", type: String }
    };
  }
  constructor() {
    super();
    this.helpTextDirection = "right";
  }
  render() {
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="header">
        <div class="header-text-wrapper">
          <span class="header-text">${this.text}</span>
          ${this.renderInfo()}
        </div>
        <div>
          <slot name="top-right"></slot>
        </div>
      </div>
      <slot></slot>
    `;
  }
  renderInfo() {
    if (isEmpty(this.helpText)) {
      return y``;
    } else {
      const helpText = this.helpText instanceof Function ? this.helpText() : this.helpText;
      return y`
        <isceco-popup direction="${this.helpTextDirection}">
          <i slot="wrapper" class="info circle icon"></i>
          <div slot="content">${helpText}</div>
        </isceco-popup>
      `;
    }
  }
}
customElements.define("isceco-card", Card);
export { Card };
